<template>
  <div class="user-profile">
    <div class="row user">
      <!-- <div class="col-sm-4">
        <img class="mb-4 user-image" :src="defaultImageUrl" />
      </div> -->
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{ user.firstName }} {{ user.lastName }}</h5>
            <h6 class="card-subtitle text-muted">
              {{ user.roles.join(", ") }}
            </h6>
            <p class="card-text mt-3 bio-text">
              {{ user.bio ? user.bio : "This user has not yet added a bio." }}
            </p>
            <p v-if="showEditLink">
              <b-button
                variant="primary"
                size="sm"
                class="action-button red"
                @click="goToEditPage"
              >
                <b-icon-person-lines-fill
                  class="action-icon"
                ></b-icon-person-lines-fill>
                edit user</b-button
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="table table-hover mt-4">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">Email</th>
            <td scope="row">{{ user.email }}</td>
          </tr>
          <tr>
            <th scope="row">Pronouns</th>
            <td scope="row">{{ user.pronouns }}</td>
          </tr>
          <tr>
            <th scope="row">Phone</th>
            <td scope="row">
              <ul class="number-container">
                <li v-for="number in user.phoneNumbers" :key="number.id">
                  <span class="number">{{
                    number.number | VMask("(###) ###-####")
                  }}</span>
                  <span class="number-type">{{ number.type }}</span>
                </li>
              </ul>
            </td>
          </tr>
          <template v-if="user.studentProfile">
            <tr>
              <th scope="row">Last School Attended</th>
              <td scope="row">{{ user.studentProfile.transferSchool }}</td>
            </tr>
            <tr>
              <th scope="row">First Year as Student</th>
              <td scope="row">{{ user.studentProfile.studentStartYear }}</td>
            </tr>
            <tr>
              <th scope="row">Major</th>
              <td scope="row">{{ user.studentProfile.major }}</td>
            </tr>
          </template>
          <template v-if="user.mentorProfile">
            <tr>
              <th scope="row">Specialty</th>
              <td scope="row">{{ user.mentorProfile.specialty }}</td>
            </tr>
            <tr>
              <th scope="row">Company</th>
              <td scope="row">{{ user.mentorProfile.company }}</td>
            </tr>
            <tr>
              <th scope="row">First Year as Mentor</th>
              <td scope="row">
                {{ months[user.mentorProfile.mentorStartMonth].text }}
                {{ user.mentorProfile.mentorStartYear }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// TODO Ask Sree -- why not use bootstrap vue?
import { BButton, BIconPersonLinesFill } from "bootstrap-vue";
import { RightTrim } from "../lib/Sanitation";
import { VueMaskFilter } from "v-mask";

import { MonthsSelectOptions } from "../lib/Constants";

export default {
  name: "UserProfileView",
  data: function() {
    return {
      months: MonthsSelectOptions
    };
  },
  components: { BButton, BIconPersonLinesFill },
  filters: { VMask: VueMaskFilter },
  props: {
    user: Object,
    profileImagesRootUrl: String,
    userAdminUrl: String,
    defaultImageUrl: String,
    showEditLink: { type: Boolean, default: false }
  },
  methods: {
    alert: msg => alert(msg),
    goToEditPage() {
      let cleanUrl = RightTrim("/", this.userAdminUrl);
      window.location = `${cleanUrl}/${this.user.id}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.action-icon {
  font-size: 1.5rem;
  margin-right: 0.25rem;
}
.action-button {
  margin: 0.25rem;
}

.user-name {
  font-weight: 600;
}
.user-email {
  font-size: 80%;
  display: block;
}
.number-type {
  margin-left: 1rem;
  color: #8a8a8a;
}
.number-container {
  list-style-type: none;
}

.bio-text {
  white-space: pre-line;
}
</style>
